import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

// import "./styles/chakra-petch.css";
// import "./styles/font-awesome.min.css";
// import WebFont from 'webfontloader';
import App from "./App";
import * as serviceWorker from "./serviceWorker";
// import ModRouter from "./routes/ModRouter";
import { createStore } from "redux";
import rootReducer from "./store/reducer/rootReducer";
import { Provider, useSelector } from "react-redux";
import { persistStore, persistReducer } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import { encryptTransform } from "redux-persist-transform-encrypt";
import localStorage from "redux-persist/es/storage";
import store, { persistor } from './store/store';

// import Test from "./pages/Test";

// const encryptor = encryptTransform({
//   secretKey: "root",
//   onError: function (error) { },
// });

// const persistConfig = {
//   key: "AyTbepliobWqqCxTYqa",
//   storage: localStorage,
//   transforms: [encryptor],
// };

// const persistedReducer = persistReducer(persistConfig, rootReducer);
// let _store = createStore(persistedReducer);
// let _persistor = persistStore(store);

const root = ReactDOM.createRoot(document.getElementById("root"));


root.render(
  <Provider store={store}>
    {" "}
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);



// ReactDOM.render(
//   // <React.StrictMode>
//   <App />,
//   // </React.StrictMode>,
//   document.getElementById("root")
// );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
